import JoinSection from './JoinSection';

export default JoinSection;
